// src/components/navbar/data/navbarTheme.js

export const NAVBAR_THEME = {
  blue: "#0868f2",
  blueDark: "#0648b8",
  orange: "#ff7900",
  orangeDark: "#e86600",
  ink: "#172033",
  muted: "#64748b",
};

export const NAVBAR_CONFIG = {
  height: 76,
  scrollThreshold: 24,
  logo: "/logo_monappliclub2026_nav.png",
};